import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/Users/khulan/projects/bolorsoft/eduge-input-man/frontend/layouts/default.vue").then(m => m.default || m)),
  landing: defineAsyncComponent(() => import("/Users/khulan/projects/bolorsoft/eduge-input-man/frontend/layouts/landing.vue").then(m => m.default || m))
}